//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

import { UserSessionService } from '../../../services/user-session'

import { BasicParameter, BasicParameterSize } from './extensions/basic.parameters.extension'
import { IMRBaseControlController } from '../base'
import { IIMRParameters, IMRParametersOptions, IIMRParemetersExtension } from './parameters.interfaces'


export class IMRParametersController<TParametersExtension> extends IMRBaseControlController<IIMRParameters<TParametersExtension>, IMRParametersOptions<TParametersExtension>> {

    //#region Members

    public isLoading: boolean
    public parameters: BasicParameter[]
    public isShowPattern: boolean

    private currentExtension: IIMRParemetersExtension
    private isShowEmpty: boolean
    private scrollViewOptions: DevExpress.ui.dxScrollViewOptions

    //#endregion


    // Ctor

    public constructor(private readonly userSessionService: UserSessionService) {
        super()
    }

    //#endregion


    //#region Lifecycle

    protected initialize(): JQueryPromise<void> {
        this.setDefaults()
        this.setOptions()

        if (this.currentExtension != null) {
            this.isLoading = true

            return $.when(
                this.currentExtension.initialize(this.userSessionService),
                this.initializeScrollView()
            )
                .then(() => {
                    this.parameters = this.currentExtension.getPrameters()
                    this.isLoading = false
                })
        }
    }

    private setDefaults(): void {
        this.isShowEmpty = false
        this.isShowPattern = true
    }

    private setOptions(): void {
        if (this.options != null) {
            if (this.options.showEmpty != null) {
                this.isShowEmpty = this.options.showEmpty
            }

            if (this.options.extension != null) {
                this.currentExtension = this.options.extension
            }

            if (this.options.showPattern != null) {
                this.isShowPattern = this.options.showPattern
            }
        }
    }

    //#endregion

    //#region IIMRParameters Implementation

    public get extension(): TParametersExtension { return this.currentExtension as any as TParametersExtension }

    public refresh(): JQueryPromise<void> {
        if (this.currentExtension != null) {
            this.isLoading = true

            return this.currentExtension
                .refresh()
                .then(() => {
                    this.parameters = this.currentExtension.getPrameters()
                })
                .always(() => {
                    this.isLoading = false
                })
        }

        return $.Deferred<void>().resolve().promise()
    }

    public setShowEmpty(showEmpty: boolean): void {
        if (showEmpty != null) {
            this.isShowEmpty = showEmpty
        }
    }

    //#endregion

    //#region Component

    public getParameterCheckBoxOptions(parameter: BasicParameter): DevExpress.ui.dxCheckBoxOptions {
        if (parameter != null) {
            return {
                readOnly: true,
                value: parameter.value,
                height: '18px',
                width: '18px'
            }
        }

        return null
    }

    public getParameterColor(parameter: BasicParameter): string {
        if (parameter != null) {
            return parameter.color
        }

        return null
    }

    public isLargeParameter(parameter: BasicParameter): boolean {
        return parameter != null && parameter.size === BasicParameterSize.Large
    }

    public isSmallParameter(parameter: BasicParameter): boolean {
        return parameter != null && parameter.size === BasicParameterSize.Small
    }

    public isParameterCheckBox(parameter: BasicParameter): boolean {
        return parameter != null && parameter.isCheckBox
    }

    public isParameterHTML(parameter: BasicParameter): boolean {
        return parameter != null && parameter.isHTML
    }

    public isParameterVisible(parameter: BasicParameter): boolean {
        if (parameter != null) {
            return this.isShowEmpty || !this.isShowEmpty && parameter.value != null
        }

        return false
    }

    //#endregion

    //#region Scroll View

    private initializeScrollView(): JQueryPromise<any> {
        this.scrollViewOptions = {
            height: '100%',
            width: '100%'
        }

        return super.waitForOnInitialized(this.scrollViewOptions)
    }

    //#endregion
}
